import React from 'react';
import { Link } from 'gatsby';

const Navigation = () => {
    return (<div >
        <Link to="/" style={{
            textDecoration: "none"
        }}><p>Home</p></Link>
        <Link to="solution-architecture" style={{
            textDecoration: "none"
        }}><p>Solution Architecture</p></Link>
        <Link to="computer-science" style={{
            textDecoration: "none"
        }}><p>Computer Science</p></Link>
        <Link to="front-end" style={{
            textDecoration: "none"
        }}><p>Frontend</p></Link>
        <Link to="data-analytics" style={{
            textDecoration: "none"
        }}><p>Data Analytics</p></Link>
    </div>)
}

export default Navigation;
